export default "__VITE_ASSET__CG4XqdP7__"